import { useEffect, useState, type ReactNode } from "react";
import { createPortal } from "react-dom";

const DESKTOP_MQ = "(min-width: 1024px)";

/**
 * Desktop: rendert Kinder per Portal an document.body, damit position:fixed
 * am Viewport greift (unabhängig von transform/animation auf Page-Wrappern).
 * Mobile: bleibt im normalen Dokumentfluss.
 */
export function ViewportEdgeNav({ children }: { children: ReactNode }) {
  const [desktop, setDesktop] = useState(() =>
    typeof window !== "undefined" ? window.matchMedia(DESKTOP_MQ).matches : false,
  );

  useEffect(() => {
    const mq = window.matchMedia(DESKTOP_MQ);
    const sync = () => setDesktop(mq.matches);
    sync();
    mq.addEventListener("change", sync);
    return () => mq.removeEventListener("change", sync);
  }, []);

  if (typeof document === "undefined" || !desktop) {
    return <>{children}</>;
  }

  return createPortal(children, document.body);
}
